<template>
    <b-form @submit="onSubmit" autocomplete="off" class="form-horizontal">
      <!-- Page title -->
      <b-row>
          <b-col md="12">
              <h3 class="text-themecolor">Order <span v-if="command.id">{{$t('klantrelaties.bewerker')}}</span><span v-else>{{$t('klantrelaties.aanmaker')}}</span></h3>
          </b-col>
      </b-row>
      <!-- Page title -->
      
      <!-- Form content -->
      <b-row>
        <b-col md="12">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title">{{$t('carpetline.algemeneinformatie')}}</h4>
              <!-- reference -->
              <b-form-group :label="$t('datatables.referentie')" class="form-label">
                <b-form-input v-model="command.reference" type="text" />
                <validation element="reference" :message="$t('validatie.geefeenreferentieop')" />
              </b-form-group>
              <b-row>
              <b-col md="6">
              <!-- supplierCarpet -->
              <b-form-group :label="$t('carpetline.leveranciertapijt')" class="form-label">
                <b-form-input v-model="command.supplierCarpet" type="text" />
                <validation element="delivered_by" :message="$t('validatie.ditveldmagnietleegzijn')" />
              </b-form-group>
              </b-col>
              <b-col md="6">
              <!-- transportFinishedProduct -->
              <b-form-group :label="$t('carpetline.vervoergereedproduct')" class="form-label">
                <b-form-select v-model="command.transportFinishedProduct">
                  <option :value="0">{{$t('carpetline.ophalen')}}</option>
                  <option :value="1">{{$t('carpetline.verzenden')}}</option>
                </b-form-select>
                <validation element="delivery_id" :message="$t('validatie.maakeenkeuzevoorvervoer')" />
              </b-form-group>
              </b-col>
              </b-row>
              <!-- info -->
              <b-form-group :label="$t('carpetline.naleveringtapijtproductietijd7werkbaredagen')">
              </b-form-group>
            </div>
          </div>
          <div class="card">
            <div class="card-body">
              <h4 class="card-title">{{$t('order.orderregels')}}</h4>
              <div v-for="orderLine in command.orderLines" v-bind:key="orderLine.id">
                  <hr/>
                  <b-row>
                    <b-col sm="12" md="10">
                      <b-row>
                        <b-col md="6" lg="3">
                          <small class="text-muted">{{$t('carpetline.kwaliteitsnaamenkleur')}}</small>
                          <h6>{{orderLine.qualityName}}</h6>            
                        </b-col>
                        <b-col md="6" lg="3">
                          <small class="text-muted">{{$t('carpetline.afwerking')}}</small>
                          <h6>{{orderLine.semiFinishDescription}}</h6>            
                        </b-col>
                        <b-col md="6" lg="3">
                          <small class="text-muted">{{$t('carpetline.afwerkingsoptie')}}</small>
                          <h6>{{orderLine.articleDescription != '' ? orderLine.articleDescription : 'Niet van toepassing' }}</h6>            
                        </b-col>
                        <b-col md="6" lg="3">
                          <small class="text-muted">{{$t('carpetline.kleur')}}</small>
                          <h6>{{orderLine.colorDescription != '' ? orderLine.colorDescription : 'Niet van toepassing'}}</h6>            
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col md="6" lg="3">
                          <small class="text-muted">{{$t('carpetline.vorm')}}</small>
                          <h6>{{getShapeText(orderLine.shape)}}</h6>            
                        </b-col>
                        <b-col  md="6" lg="6">
                          <small class="text-muted">{{$t('carpetline.afmetingen')}}</small>
                          <h6 v-if="orderLine.length && orderLine.width">{{orderLine.length}} x {{orderLine.width}} cm (lxb)</h6>
                          <h6 v-else-if="orderLine.diameter">{{orderLine.diameter}} cm (rond)</h6> 
                          <h6 v-else>{{$t('carpetline.afwijkendemaatvoering')}}</h6>
                        </b-col>
                        <b-col md="6" lg="3">
                          <small class="text-muted">{{$t('carpetline.aantal')}}</small>
                          <h6>{{orderLine.quantity}}</h6>            
                        </b-col>
                      </b-row>
                    </b-col>
                    <b-col sm="12" md="2">
                      <b-btn class="waves-effect pull-right" size="sm" v-on:click="removeOrderLine(orderLine.lineNumber)" variant="danger">Regel verwijderen</b-btn>
                    </b-col>
                  </b-row>
              </div>
              <hr/>
              <div is="OrderLinesForm" v-on:add-new-line="addNewOrderLine"></div>
            </div>
          </div>
          <div class="card">
            <div class="card-body">
              <h4 class="card-title">{{$t('carpetline.opmerking')}}</h4>
              <!-- note -->
              <b-form-group class="form-label">
                <b-form-textarea v-model="command.Note" type="textarea" rows="3" />
              </b-form-group>
            </div>
          </div>
        </b-col>
      </b-row>
      <!-- Form content -->

      <b-row>
          <b-col md="12">
              <b-button @click="goTo(command.id ? 'detail' : 'index')" variant="secondary">{{$t('buttons.terugnaaroverzicht')}}</b-button>
              <b-button type="submit" variant="themecolor" v-if="command.orderLines.length > 0">{{$t('buttons.bestellen')}}</b-button>
          </b-col>
      </b-row>
      <br/>
    </b-form>
</template>
<script>
"use strict";

//Import store
import { mapGetters, mapActions } from "vuex";

//Import command
import Command from "./command";
import OrderLinesForm from "./orderlines/Form";

import $ from 'jquery';

export default {
  components: {
    OrderLinesForm
  },
  data() {
    return {
      orderList: [],
      command: new Command(),
      customerRelations: []
    };
  },
  computed: {
    ...mapGetters("carpetline", ["orders"])
  },
  methods: {
    addNewOrderLine(lineDetails) {
      this.command.orderLines.push(lineDetails);
    },
    removeOrderLine(lineNumber) {
      this.command.orderLines = $.grep(this.command.orderLines, function(e) {
        return e.lineNumber !== lineNumber;
      });
    },
    getShapeText(shape) {
      let shapeText = '';
      switch(shape) {
        case "0", 0:
          shapeText = 'Recht';
          break;
        case "1", 1:
          shapeText = 'Rond';
          break;
        case "2", 2:
          shapeText = 'Afwijkend';
          break;
        default:
          shapeText = 'Onbekend'
          break;
        }
        return shapeText;
    },
    ...mapActions("carpetline", ["create", "update"]),
    onSubmit(event) {
      event.preventDefault();
      const vm = this;
      const payload = {
        resource: "orders",
        params: vm.command
      };
      vm.create(payload).then(() => {
        vm.goTo("index");
      });
    },
    goTo(name) {
      var vm = this;
      vm.$router.push({ name: `orders:${name}` });
    }
  }
};
</script>
